import { render, staticRenderFns } from "./EditTeacherDialog.vue?vue&type=template&id=842e945a&scoped=true&"
import script from "./EditTeacherDialog.vue?vue&type=script&lang=js&"
export * from "./EditTeacherDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditTeacherDialog.vue?vue&type=style&index=0&id=842e945a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842e945a",
  null
  
)

export default component.exports